import { Component, ViewChild } from '@angular/core';
import { AttendanceService } from '../../../Model/Attendance/attendance.service';
import { LeaveService } from '../../../Model/Leave/leave.service';
import { UtilityService } from '../../../Model/utility/utility.service';
import { SessionService } from '../../../Util/Session/session.service';
import { ToastService, toastTypeEnum } from '../../../Util/Toast/toast.service';
import { CommonService } from '../../../Model/Common/common.service';
import { CustomDateParserFormatter } from '../../../Util/DateFormat/date-format.service';
import moment from 'moment';
import { CommonModule } from '@angular/common';
import { NgbDateParserFormatter, NgbDatepickerModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { Subject } from 'rxjs';
import { RouterModule } from '@angular/router';
import { LoaderComponent } from '../../../Component/Loader/loader/loader.component';
import { TooltipService } from '../../../Util/Tooltip/tooltip.service';

@Component({
  selector: 'app-attendance',
  standalone: true,
  imports: [CommonModule, NgbDatepickerModule, FormsModule, DataTablesModule, RouterModule, LoaderComponent],
  providers: [
    { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },
  ],
  templateUrl: './attendance.component.html',
  styleUrl: './attendance.component.scss'
})
export class AttendanceComponent {
  isDisabled: boolean = false;
  user = [] as any;

  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;
  AttendanceHistory = [];
  CurrentTime = null as any;
  IntervalId: any;
  LateCheckInDuration: string = '0h 0m 0s';
  Duration: string = '0h 0m 0s';
  LeaveTypes = [] as any;
  EmpMasterID = 0;
  ToDayDate = null as any;
  AttendanceDetail = {
    EmpMasterId: null,
    EmployeeName: null,
    EmpType: null,
    DesignationID: null,
    DesignationName: null,
    DutyID: null,
    DutyName: null,
    BranchID: null,
    BranchName: null,
    SiteID: null,
    SiteName: null,
    ShiftMasterID: null,
    ShiftTitle: null,
    AttendanceDate: null as any,
    InTime: null as any,
    OutTime: null as any,
    WorkingHour: null,
    AttendanceStatus: null,
    AttendanceStatusOut: null,
    AttendanceRemark: null,
    AttendanceRemarkOut: null,
    DailyAttendancePhoto: null,
    DailyAttendancePhotoOut: null,
    OpenMonth: null,
    OpenYear: null,
    BiometricAttendanceId: null,
    IsManual: null,
    AttendanceMatchPercentage: null,
    Latitude: null,
    Longitude: null,
    Altitude: null,
    NearByLocationName: null,
    BillableOT: null,
    NonBillableOT: null,
    RegularizationID_IN: null,
    RegularizationID_OUT: null,
    LeaveID: null,
    AttendanceDescription: null,
    ApprovalStatus: null,
    GeoTagged: null,
    MobileName: null,
    AccessCard: null,
    MobileId: null,
    Address: null,
    Remark: null,
    NearByLocationName1: null,
    IsOtherDuty: null,
    WebCheckInOut: null,
    MobileCheckInOut: null,
    GeoTagging: null,
    SiteQRCodeScanning: null,
    EmployeeQRCodeScanning: null,
    Selfie: null,
    SelfieType: null,
    EmployeeNotCheckIn: null,
    IsOtherDuty1: null,
    IsAttendanceAll: null,
    RestrictIP: null,
    IP: null,
    AttendanceType: null,
    Duration: null,
    HalfDayDuration: null,
    OTApplicable: null,
    OTApplicableIn: null,
    FirstCheckInLate: null,
    LastCheckOutEarly: null,
    Deviation: null,
    DeviationMoreThan: null,
    DeviationMoreThanPeriod: null,
    DeviationOccurMultiplyOf: null,
    DeviationOccurMultiplyOFPeriod: null,
    LeaveDeductDay: null,
    LeaveDeductType: null,
    ShiftMargin: null,
    HourBeforeShiftStart: null,
    HourAfterShiftStart: null,
    Insentive: null,
    AttendanceGreaterThan: null,
    AttendanceOccurMultiplyOf: null,
    AttendanceOccurMultiplyOfPeriod: null,

    IsCheckIn: false,//
    IsAttendaceClose: false,
    SelectType: 'InsertUpdate',//

    // EmpMasterId: null as any,
    // EmpCode: null,
    // FUllName: null,
    // DesignationID: null,
    // DutyID: null,
    // BranchID: null as any,//
    // SiteId: null,
    // ShiftMasterID: null,
    // AttendanceDate: null as any,//
    // InTime: null as any,//
    // OutTime: null as any,//
    // DailyAttendancePhoto_IO: null,//
    // AttendanceMatchPercentage: null,//
    // Latitude: null,//
    // Longitude: null,//
    // Altitude: null,//
  };

  ShiftDetail = {
    ShiftFrom: '09:00:00 AM' as any,
    ShiftTo: '06:00:00 PM',
  };

  Filter = {
    FromDate: null as any,
    ToDate: null as any,
    ApprovalStatus: 'ALL',
  }
  dtoptions: DataTables.Settings = {};
  constructor(
    private attendance: AttendanceService,
    private session: SessionService,
    private toast: ToastService,
    private utility: UtilityService,
    private leave: LeaveService,
    private dateFromat: CustomDateParserFormatter,
    protected common: CommonService,
    private dateFormat: CustomDateParserFormatter,
    private tooltip: TooltipService,
  ) {
    this.common.getPageRights();
    this.user = this.session.GetUserDetails();
    this.SelectDate('RegistrationDate', null, null);
    this.dtoptions = { ...this.common.commonDToptions };
  }

  ngOnInit(): void {
    this.AttendanceDetail.EmpMasterId = this.user.UserId;
    this.EmpMasterID = this.user.UserId;
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  Validate(form: any) {
    if (form.valid) {
      this.GetDailyAttendanceInOutHistory();
    } else {
      form.submitted = true;
    }
  }

  // CheckIn() {
  //   if (this.AttendanceDetail.WebCheckInOut) {
  //     if (!this.AttendanceDetail.IsCheckIn) {
  //       this.AttendanceDetail.IsCheckIn = true;
  //       this.AttendanceDetail.InTime = this.CurrentTime;
  //       this.getIPAddress()
  //     }
  //   } else {
  //     this.toast.show({ message: "Web attendance not allowed", type: toastTypeEnum.danger });
  //   }
  // }

  // CheckOut() {
  //   if (this.AttendanceDetail.WebCheckInOut) {
  //     if (this.AttendanceDetail.IsCheckIn) {
  //       this.AttendanceDetail.IsCheckIn = false;
  //       clearInterval(this.IntervalId);
  //       this.IntervalId = null;
  //       this.AttendanceDetail.OutTime = this.CurrentTime;
  //       this.getIPAddress();
  //     }
  //   } else {
  //     this.toast.show({ message: "Web attendance not allowed", type: toastTypeEnum.danger });
  //   }
  // }

  // AttendanceInOutSave(): any {
  //   this.isDisabled = true;
  //   if (this.AttendanceDetail.IsCheckIn) {
  //     this.AttendanceDetail.InTime = this.AttendanceDetail.InTime._i.toString();
  //   } else if (!this.AttendanceDetail.IsCheckIn) {
  //     this.AttendanceDetail.OutTime = this.AttendanceDetail.OutTime._i.toString();
  //   }
  //   this.attendance.AttendanceInOutSave(this.AttendanceDetail).subscribe({
  //     next: (response) => {
  //       if (response.Error_Code == '01') {
  //         if (this.AttendanceDetail.IsCheckIn) {
  //           this.CheckInStart(this.CurrentTime, true);
  //         } else if (!this.AttendanceDetail.IsCheckIn) {
  //           this.AttendanceDetail.OutTime = this.CurrentTime;
  //         }
  //         this.toast.show({ message: response.Error_Message, type: toastTypeEnum.success });
  //         this.AttendanceDetail.AttendanceDate = null;
  //         this.AttendanceDetail.InTime = null;
  //         this.AttendanceDetail.OutTime = null;
  //       } else {
  //         this.toast.show({ message: response.Error_Message, type: toastTypeEnum.danger });
  //       }
  //       this.SelectDate('RegistrationDate', null, null);
  //       this.isDisabled = false;
  //       return true;
  //     },
  //     complete: () => {
  //       //this.GetDailyAttendanceInOut();
  //       return true;
  //     },
  //     error: (error) => {
  //       this.isDisabled = false;
  //       return false;
  //     },
  //   });
  // }

  // CheckInStart(AttendanceDateTime: any, IsNewChekin: boolean) {
  //   this.ShiftDetail.ShiftFrom = moment(new Date(this.CurrentTime._i.split(' ')[0] + ' ' + this.ShiftDetail.ShiftFrom));
  //   this.AttendanceDetail.InTime = AttendanceDateTime;
  //   this.AttendanceDetail.OutTime = this.CurrentTime;
  //   if (this.AttendanceDetail.InTime > this.ShiftDetail.ShiftFrom) {
  //     this.LateCheckInDuration = this.calculateLate(this.AttendanceDetail.InTime, this.ShiftDetail.ShiftFrom);
  //   } else {
  //     this.LateCheckInDuration = '';
  //   }

  //   if (this.IntervalId != null) {
  //     clearInterval(this.IntervalId);
  //     this.IntervalId = null;
  //   }

  //   this.IntervalId = setInterval(() => {
  //     this.AttendanceDetail.OutTime = moment(this.AttendanceDetail.OutTime).add(moment.duration(1, 'second'));
  //     this.CalculateTimeDifference();
  //   }, 1000);
  // }

  // CalculateTimeDifference() {
  //   const startTime = this.AttendanceDetail.InTime;
  //   const endTime = this.AttendanceDetail.OutTime;
  //   const diff = endTime - startTime;
  //   const hours = Math.floor(diff / (1000 * 60 * 60));
  //   const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
  //   const seconds = Math.floor((diff % (1000 * 60)) / 1000);
  //   this.Duration = `${hours}h ${minutes}m ${seconds}s`;
  // }

  // calculateLate(actualTime: any, expectedTime: any): string {
  //   const diff = actualTime - expectedTime;
  //   if (diff > 0) {
  //     const hoursLate = Math.floor(diff / (1000 * 60 * 60)); // Convert milliseconds to hours
  //     const minutesLate = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60)); // Convert remaining milliseconds to minutes
  //     const secondsLate = Math.floor((diff % (1000 * 60)) / 1000); // Convert remaining milliseconds to seconds

  //     return `${hoursLate} h ${minutesLate} m ${secondsLate} s`;
  //   } else {
  //     return 'On time';
  //   }
  // }

  // GetDailyAttendanceInOut() {
  //   this.isDisabled = true;
  //   this.attendance.GetDailyAttendanceInOut({ SelectType: 1, EmpMasterId: this.AttendanceDetail.EmpMasterId, MonthName: this.dateFromat.fullmonth[this.ToDayDate.month - 1], YearName: this.ToDayDate.year }).subscribe({
  //     next: (response) => {
  //       if (response.toString() != '') {
  //         this.AttendanceDetail = response[0];
  //         this.AttendanceDetail.SelectType = 'InsertUpdate';
  //         // this.AttendanceDetail.InTime = null;
  //         // this.AttendanceDetail.OutTime = null;
  //         if (moment(response[0].AttendanceDate).isSame(this.dateFromat.format(this.ToDayDate))) {
  //           if (response[0].InTime != null && response[0].OutTime == null) {
  //             this.AttendanceDetail.IsCheckIn = true;
  //             this.AttendanceDetail.InTime = moment(response[0].InTime);
  //             this.GetDateTime(false);
  //           } else if (response[0].InTime != null && response[0].OutTime != null) {
  //             this.AttendanceDetail.IsAttendaceClose = true;
  //             this.AttendanceDetail.IsCheckIn = false;
  //             this.AttendanceDetail.InTime = moment(response[0].InTime);
  //             this.AttendanceDetail.OutTime = moment(response[0].OutTime);
  //             this.CalculateTimeDifference();
  //             this.GetDateTime(false);
  //           }
  //         } else {
  //           if (response[0].InTime != null && response[0].OutTime == null) {
  //             this.AttendanceDetail.IsCheckIn = true;
  //             this.AttendanceDetail.InTime = moment(response[0].InTime);
  //             this.GetDateTime(false);
  //           } else if (response[0].InTime != null && response[0].OutTime != null) {
  //             this.AttendanceDetail.InTime = null;
  //             this.AttendanceDetail.OutTime = null;
  //             this.GetDateTime(false);
  //           }
  //         }
  //       }
  //       this.isDisabled = false;
  //     },
  //     complete: () => {
  //     },
  //     error: (error) => {
  //       this.isDisabled = false;
  //     },
  //   });
  // }

  GetDailyAttendanceInOutHistory() {
    if (moment(this.dateFormat.format(this.Filter.ToDate), 'DD MMM YYYY').isSameOrAfter(moment(this.dateFormat.format(this.Filter.FromDate), 'DD MMM YYYY'))) {
      this.isDisabled = true;
      //this.attendance.GetDailyAttendanceInOutHistory({ SelectType: 1, EmpMasterId: this.AttendanceDetail.EmpMasterId, MonthName: this.dateFromat.fullmonth[this.Filter.MonthYear.month - 1], YearName: this.Filter.MonthYear.year }).subscribe({
      this.attendance.GetDailyAttendanceInOut({ SelectType: 2, EmpMasterId: this.AttendanceDetail.EmpMasterId, FromDate: this.dateFromat.format(this.Filter.FromDate), ToDate: this.dateFromat.format(this.Filter.ToDate), ApprovalStatus: this.Filter.ApprovalStatus }).subscribe({
        next: (response) => {
          //if (response.toString() != '') {
          this.AttendanceHistory = response;
          this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.destroy();
            this.dtTrigger.next(null);
          });
          this.isDisabled = false;
          //}
          this.isDisabled = false;
        },
        complete: () => {
        },
        error: (error) => {
          this.isDisabled = false;
        },
      });
    } else {
      this.toast.show({ message: this.tooltip.Message.FromDateToDateMessgae, type: toastTypeEnum.danger });
    }
  }

  // GetDateTime(IsAction: boolean) {
  //   this.isDisabled = true;
  //   if (!this.AttendanceDetail.IsAttendaceClose || !IsAction) {
  //     this.utility.GetDateTime().subscribe({
  //       next: (response) => {
  //         if (IsAction && !this.AttendanceDetail.IsCheckIn) {
  //           this.AttendanceDetail.AttendanceDate = (moment(response.Current_Date).year() + '-' + (moment(response.Current_Date).month() + 1) + '-' + moment(response.Current_Date).date()).toString();
  //         } else {
  //           this.AttendanceDetail.AttendanceDate = (moment(this.AttendanceDetail.InTime).year() + '-' + (moment(this.AttendanceDetail.InTime).month() + 1) + '-' + moment(this.AttendanceDetail.InTime).date()).toString();
  //         }
  //         this.CurrentTime = moment(response.Current_Date);
  //         if (!this.AttendanceDetail.IsCheckIn && IsAction) {
  //           this.CheckIn();
  //         } else if (this.AttendanceDetail.IsCheckIn && IsAction) {
  //           this.CheckOut();
  //         } else if (this.AttendanceDetail.IsCheckIn && !IsAction) {
  //           this.CheckInStart(this.AttendanceDetail.InTime, true);
  //         }
  //         this.isDisabled = false;
  //       },
  //       complete: () => { },
  //       error: (error) => {
  //         this.isDisabled = false;
  //       },
  //     });
  //   } else {
  //     this.toast.show({ message: 'Attendace not allowed for today.', type: toastTypeEnum.danger });
  //   }
  // }

  SelectDate(SelectType: string, BirthDate: any, JoiningDate: any) {
    this.isDisabled = true;
    return this.utility.SelectDate({ 'SelectType': SelectType, 'BirthDate': BirthDate, 'JoiningDate': JoiningDate, }).subscribe({
      next: (response) => {
        if (SelectType == 'RegistrationDate') {
          this.ToDayDate = this.dateFromat.parse(response.Table[0].RegistrationDate);
          this.Filter.FromDate = this.dateFromat.parse(response.Table[0].RegistrationDate);
          this.Filter.ToDate = this.dateFromat.parse(response.Table[0].RegistrationDate);

          this.Filter.FromDate.day = 1;
          this.Filter.ToDate.day = parseInt(moment(response.Table[0].RegistrationDate).endOf('month').format('D'));
        }
        this.GetDailyAttendanceInOutHistory();
        this.isDisabled = false;
      },
      complete: () => {
        //this.GetDailyAttendanceInOut();
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  // getIPAddress() {
  //   this.isDisabled = true;
  //   return this.utility.getIPAddress().subscribe({
  //     next: (response) => {
  //       this.AttendanceDetail.IP = response.ip;
  //       this.isDisabled = false;
  //     },
  //     complete: () => {
  //       this.AttendanceInOutSave();
  //     },
  //     error: (error) => {
  //       this.isDisabled = false;
  //     },
  //   });
  // }

  Clear() {
    this.AttendanceHistory = [];
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next(null);
    });
  }
}
